import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"

interface UseCreateEstablishmentLeadContractProps {
  establishmentLeadId?: string
  createCmContract?: boolean;
  payload?: object
  onSuccess?: () => void
  onError?: () => void
}

export const useCreateEstablishmentLeadContract = ({
  establishmentLeadId,
  createCmContract,
  payload,
  onSuccess,
  onError,
}: UseCreateEstablishmentLeadContractProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['createEstablishmentLeadContract'],
    mutationFn: async () => {
      const lead = {
        contract_attributes: { _create: true, ...payload },
        maintenance_contract_attributes: createCmContract ? { _create: true } : undefined,
      }

      return privateAxios.put(`/funnel/establishment/leads/${establishmentLeadId}`, {
        lead
      })
    },
    onSuccess,
    onError,
  })
}
